const ATTRIBUTION_PARAM = 'lm_attribution_id';
const FIRST_TOUCH_KEY = 'lm_first_touch_attribution_id';
const OPAQUE_ID_PATTERN = /^[A-Za-z0-9_-]{12,100}$/;

export function isValidAttributionId(value: string | null | undefined): value is string {
    return typeof value === 'string' && OPAQUE_ID_PATTERN.test(value);
}

function cleanAttributionParam() {
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has(ATTRIBUTION_PARAM)) return;
        url.searchParams.delete(ATTRIBUTION_PARAM);
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch {
        // Registration must remain usable if History API is unavailable.
    }
}

export function captureAttributionId(): string | null {
    try {
        const stored = window.sessionStorage.getItem(FIRST_TOUCH_KEY);
        if (isValidAttributionId(stored)) {
            cleanAttributionParam();
            return stored;
        }
        if (stored) window.sessionStorage.removeItem(FIRST_TOUCH_KEY);

        const incoming = new URLSearchParams(window.location.search).get(ATTRIBUTION_PARAM);
        cleanAttributionParam();
        if (!isValidAttributionId(incoming)) return null;

        window.sessionStorage.setItem(FIRST_TOUCH_KEY, incoming);
        return incoming;
    } catch {
        return null;
    }
}

export function clearAttributionId() {
    try {
        window.sessionStorage.removeItem(FIRST_TOUCH_KEY);
    } catch {
        // The backend already owns the ID after successful registration.
    }
}
